import { v4 as uuidv4 } from "uuid";
import { addUserReading } from "../firebase/user";
import { firestore, storage } from "../firebase/config";
import Swal from 'sweetalert2';

const divID = "blueToothReadingsDivscale";

export const onCaptureImageButtonClick2 = (uid) => {
  //const divID = "blueToothReadingsDivscale";
  document.getElementById(divID).innerHTML = `ᛒ${divID}`
   localStorage.setItem('completed_scale', 10)

  CaptureImageComponent(uid);
};

function CaptureImageComponent(userId) {
  let output = {};
  let imageURL = '';

  const handleCapture = async (userId) => {
    try {
      const imageFile = await captureImage(); 
      const fileName = `${userId}/${uuidv4()}`;
      const storageRef = storage.ref(`images/${fileName}`);
      const snapshot = await storageRef.put(imageFile);
      const downloadURL = await snapshot.ref.getDownloadURL();

      const response = await fetch(
        "https://sharprpm-ocr-scale-test1-850861419930.us-central1.run.app",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ data: downloadURL }),
        }
      );

      if (response.ok) {
        const result = await response.json();
        imageURL = downloadURL;
        output = result;
        handleConfirm(userId, imageURL);
      } else {
        throw new Error("Failed to process image");
      }
    } catch (error) {
      console.error("Error capturing or processing image:", error);
    }
  };

  const handleConfirm = async (userId, imageURL) => {
    const dateNow = new Date(Date.now());

    //const divID = "blueToothReadingsDivscale";
    document.getElementById(divID).innerHTML = `ᛒ${divID}`
     localStorage.setItem('completed_scale', 30)

    try {
      await firestore.collection("posts").add({
        userId,
        timestamp: dateNow,
        image: imageURL,
        response: output,
      });

      const labelsArray = ["Weight", "Date Time"]
      const element = [output.weight, dateNow.toLocaleString()]

      const index = 2;

      createTable( labelsArray , element, `table${index}`, imageURL, saveReading(userId, output, dateNow) );
    } catch (error) {
      console.error("Error confirming post:", error);
    }
  };

  handleCapture(userId);
}

const saveReading = (uid, reading, dateTime) => {
  const time = dateTime.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  const date = dateTime.toLocaleDateString().replace(/(\d+)\/(\d+)\/(\d+)/, "$3-$1-$2");

  let selection = "rejected";
  let validationMsg = "";
  if (reading.weight < 30 || reading.weight > 300) {
    validationMsg = "<br>- Weight out of normal range (30-300lbs)";
  }

  Swal.fire({
    title: 'Confirm Reading',
    html: `Weight: ${reading.weight} lbs <br>
    <span style="color: red; font-weight: bold;">${validationMsg}</span><br>
    If incorrect, press "Cancel", otherwise press "OK".`,
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'OK',
    cancelButtonText: 'Cancel',
  }).then((result) => {
    if (result.isConfirmed) {
      // User clicked "OK"

      addUserReading({
        uid: uid,
        add: {
          devices: {
            scale: {
              time: time,
              note: `Picture Captured`,
              status: 'Accepted',
              date: date,
              reading: {
                Weight: reading.weight,
              },
              device: {
                manufacturer: "Device",
                model: "Camera",
              },
            },
          },
        },
      });
      console.log('Reading confirmed');
      document.getElementById(`disposition_${divID}`).innerHTML = "Reading saved!"
      new Audio('/audio/ReadingAccepted.mp3').play();
      //return "saved"
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      // User clicked "Cancel"

      addUserReading({
        uid: uid,
        add: {
          devices: {
            scale: {
              time: time,
              note: `Picture Captured`,
              status: 'Rejected',
              date: date,
              reading: {
                Weight: reading.weight,
              },
              device: {
                manufacturer: "Device",
                model: "Camera",
              },
            },
          },
        },
      });
      alert("Reading canceled. Please try again.");
      console.log('Reading canceled');
      document.getElementById(`disposition_${divID}`).innerHTML = "Reading rejected."
      //return "rejected"
    }
  })

}
  

async function captureImage() {
  return new Promise((resolve, reject) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.capture = "environment";

    input.addEventListener("change", (event) => {
      const file = event.target.files[0];
      if (file) {
        resolve(file);
      } else {
        reject(new Error("No image selected"));
      }
    });

    input.click();
  });
}

const createTable = (labelArray, colDataArray,tableClassName, imageURL, disposition) => {
  //let scale_disposition = localStorage.getItem('scale_selection')

  //const divID = "blueToothReadingsDivscale";

  if (document.getElementById(divID).innerHTML === `ᛒ${divID}`) {
    document.getElementById(divID).innerHTML = "";
    localStorage.setItem('completed_scale', 100)
  }

  let table = document.createElement("table"),
    thead = document.createElement("thead"),
    tbody = document.createElement("tbody"),
    th, tr, td;

  th = document.createElement("th");
  th.innerHTML = "Camera";
  thead.appendChild(th);

  th = document.createElement("th");
  th.innerHTML = `<div id=disposition_${divID}>Reading pending</div>`;
  thead.appendChild(th);

  table.setAttribute("class", tableClassName);
  table.appendChild(thead);
  table.appendChild(tbody);

  //document.body.appendChild(table);
  document.getElementById(divID).appendChild(table);

  for (let i = 0; i < colDataArray.length; i++) {
    tr = document.createElement("tr");

    //for label
    td = document.createElement("td");
    td.innerHTML = labelArray[i];
    td.style.color = "blue";
    tr.appendChild(td);

    //for data
    td = document.createElement("td");
    td.style.color = "black";
    td.innerHTML = colDataArray[i];
    tr.appendChild(td);
    table.appendChild(tr);
  }

  tr = document.createElement("tr");
  td = document.createElement("td");
  td.colSpan = 2;

  const img = document.createElement("img");
  img.src = imageURL;
  // Set the width and height of the image (optional)
  img.width = "200";
  img.height = "150";
  // Append the image to the table data cell
  td.appendChild(img);
  tr.appendChild(td);

  tbody.appendChild(tr);
};
